import { SystemStyleObject } from "@styled-system/css";
import React, { useContext } from "react";

export type ImageProps<AddtlProps = {}> = Omit<
  JSX.IntrinsicElements["img"],
  "srcSet" | "ref" | "placeholder"
> & {
  alt?: string;
  onLoad?: () => void;
  sx?: SystemStyleObject;
} & AddtlProps;

const MinimalImage = React.forwardRef(
  (
    { alt, sx: _sx, ...props }: ImageProps,
    ref: React.ForwardedRef<HTMLImageElement>
  ) => {
    return <img ref={ref} alt={alt} {...props} />;
  }
);

type ImageComponent<AddtlProps = {}> = React.FunctionComponent<
  ImageProps<AddtlProps>
>;

type ImageComponentContextType = {
  imageComponent: ImageComponent;
};

const ImageComponentContext = React.createContext<ImageComponentContextType>({
  imageComponent: MinimalImage,
});

type ImageComponentProviderProps = {
  imageComponent: ImageComponent;
};
export const ImageComponentProvider = React.memo(
  ({
    children,
    imageComponent,
  }: React.PropsWithChildren<ImageComponentProviderProps>) => (
    <ImageComponentContext.Provider value={{ imageComponent }}>
      {children}
    </ImageComponentContext.Provider>
  )
);

export const useImageComponent = <AddtlProps = {},>() =>
  useContext(ImageComponentContext)
    .imageComponent as ImageComponent<AddtlProps>;
